import { MantineProvider as MantineProviderBase } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { getMantineThemeOverride } from '@utils/mantineTheme';
import { type FC } from 'react';

const MantineProvider: FC<React.PropsWithChildren<{}>> = ({ children }) => {
    return (
        <MantineProviderBase theme={getMantineThemeOverride()}>
            {children}

            <Notifications />
        </MantineProviderBase>
    );
};

export default MantineProvider;
